import EmployeeSelect from '../../../components/Formulaire/EmployeeSelect';
import { FaTrash } from 'react-icons/fa';
import AmountInput from "../../../components/Utils/AmountInput";

export const EmployeeDeductionRow = ({
    loan,
    index,
    onChange,
    onRemove,
    defaultAmount,
}) => {
    return (
        <tr className="border-b  border-gray-100 hover:bg-gray-50 transition-colors duration-200">
            <td className="px-4 py-4">
                <EmployeeSelect
                    value={loan.employee_select || null}
                    onChange={(selectedOption) => {
                        onChange(index, 'employee_select', selectedOption)
                    }}
                    isDisabled={false}
                    placeholder="Choisir un employé"
                    className="min-w-0"
                />
            </td>
            <td className="px-4 py-4">
                <AmountInput
                    value={loan.amount}
                    onChange={(newValue) => onChange(index, 'amount', newValue)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200 text-sm"
                    placeholder={defaultAmount || "Montant"}
                />
            </td>
            <td className="px-4 py-4">
                <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200 text-sm"
                    value={loan.dateStart || ''}
                    onChange={(e) => onChange(index, 'dateStart', e.target.value)}
                    placeholder="MM/YYYY"
                    pattern="\d{1,2}/\d{4}"
                    title="Format: MM/YYYY (ex: 03/2023)"
                />
            </td>
            <td className="px-4 py-4">
                <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200 text-sm"
                    value={loan.dateEnd || ''}
                    onChange={(e) => onChange(index, 'dateEnd', e.target.value)}
                    placeholder="MM/YYYY"
                    pattern="\d{1,2}/\d{4}"
                    title="Format: MM/YYYY (ex: 03/2023)"
                />
            </td>
            <td className="px-4 py-4 text-center">
                <button
                    type="button"
                    onClick={() => onRemove(index)}
                    className="inline-flex items-center justify-center w-8 h-8 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors duration-200"
                    title="Supprimer cette ligne"
                >
                    <FaTrash size={14} />
                </button>
            </td>
        </tr>
    );
};

export default EmployeeDeductionRow;